module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Downloads-folder-cdbee397eb19506509a13c17f5065c28.svg";